import React from "react";
import TopNav from "../components/topNav";
import Header from "../components/header";
import Footer from "../components/footer";
import PageHeader from "../components/pageHeader";
import "../assets/css/employees/employees-resources.css";


const EmployeeResources = () => {
  return (
    <div className="container resources">
      <TopNav />
      <Header />
      <PageHeader
        imageUrl="/images/employee-resources.jpg"
        title="Employee Resources."
      />
      <div className="contents resources-page">
        <div className="work-force">
          <h3 className="">Workforce Resources</h3>
          <a href="https://ctms.contingenttalentmanagement.com/cohesivestaffing/WorkforcePortal/login.cfm" target="_blank" rel="noopener noreferrer">
            https://ctms.contingenttalentmanagement.com/cohesivestaffing/WorkforcePortal/login.cfm
          </a>
        </div>
        <div className="contact-number">
          <h3 className="">Contact numbers</h3>
          <div className="contact-paylocity">
            <div className="employee-contacts">
              <div className="contact">
                <p>On Call - after hours support</p>
                <p>Call/Text: 405-367-4422</p>
              </div>
              <div className="contact">
                <p>Renda Potter</p>
                <a href="tel:405-873-9004">Call/Text: 405-873-9004</a>

                <a href="mailto:rpotter@staffingok.com">
                  Email: rpotter@staffingok.com
                </a>

                <p>
                  <b>Clinical Scheduler</b>
                </p>
              </div>

              <div className="contact">
                <p>Aften Palmer</p>
                <a href="tel:405-777-4094">Phone: 405-777-4094</a>
                <a href="mailto:apalmer@staffingok.com">
                  Email: apalmer@staffingok.com
                </a>

                <p>
                  <b>Director of Operations</b>
                </p>
              </div>

              <div className="contact">
                <p>Sarah Carter</p>
                <a href="tel:405-777-4075">Phone: 405-777-4075</a>
                <a href="mailto:scarter@staffingok.com">
                  Email: scarter@staffingok.com
                </a>
                <p>
                  <b>Payroll Coordinator</b>
                </p>
              </div>
              {/* <div className='contact'>
<p>Kim Houston</p>
<p>phone number pending</p>
<p><b>Clinical Scheduler</b></p>
                            </div> */}
              <div className="contact">
                <p>Sarah Snider</p>
                <a href="tel:405-873-9006">Call/Text: 405-873-9006</a>

                <a href="mailto:ssnider@staffingok.com">
                  Email: ssnider@staffingok.com
                </a>

                <p>
                  <b>Clinical Scheduler</b>
                </p>
              </div>
              <div className="contact">
                <p>Darin Greene</p>
                <a href="tel:405-777-4070">Call: 405-777-4070</a>

                <a href="mailto:dgreene@staffingok.com">
                  Email: dgreene@staffingok.com
                </a>

                <p>
                  <b>Staffing Admin Assistant</b>
                </p>
              </div>
              <div className="contact">
                <p>LeeAnn Abbott</p>
                <a href="tel:405-777-4069">Call: 405-777-4069</a>

                <a href="mailto:labbott@staffingok.com">
                  Email: labbott@staffingok.com
                </a>

                <p>
                  <b>Lead CNA Instructor / Compliance Specialist</b>
                </p>
              </div>
            </div>
            <div className="contact paylocity">
              <p>Paylocity</p>
              <a href="https://www.paylocity.com/" target="_blank" rel="noopener noreferrer">
                https://www.paylocity.com/
              </a>
            </div>
          </div>
        </div>
        <div className="employee-resources">
          <h3>Resources for Employees</h3>
          <p>Employees are the greatest resources a company has.</p>
          <div className="policies">
            <h3>Policies</h3>
            <ul>
              <li>Attendance Policy</li>
              <li>Holiday Policy</li>
            </ul>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EmployeeResources;
